import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Rectificatif } from '../models/Rectificatif';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { TypeAnn } from '../../../common/models/type.ann';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { BehaviorSubject } from 'rxjs';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { MapaRe } from '../../../../shared/models/component-messages/mapaRE/mapa_re';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';


@Component({
  selector: 'app-formmapa-rectificatif',
  templateUrl: './formmapa.component.html'
})
export class FormMAPA_REComponent implements OnInit {

  private LOG: LogService = new LogService(FormMAPA_REComponent);

  @Input() indexPage;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public rectificatif = new Rectificatif();
  public createForm = false;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  @Input() formName: string;
  private isLierAvisSelected :boolean=false;

  public isFormValid = true;
  public ann = new TypeAnn();
  public mapaRe = new MapaRe();
  public steps=[5,6,8,9,18,19]
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private spinner: SpinnerVisibilityService,
    private annonceurService: AnnonceurService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService
    ) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 4 }, (_, index) => index + 1);
    this.initForm();
  }

  public validateForm() {
  }

  getUid(indexPage) {
    return '_STEP_ID_' + indexPage+ '_SepSep_Rectificatif';
  }

  getUidCommon(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn'
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string'  && !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4)
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.createForm = true;
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.MAPA_RE, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.ann = formData.jsonSaisieFormulaire.ann;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.createForm = true;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(formData.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(formData.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.MAPA_RE] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:formData});
                return json;
              }
            );
          }
          else {
          this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.MAPA_RE] + '.json');
          this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.MAPA_RE] + '.json');
          this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.MAPA_RE] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  getIntitule(indexPage) {
		return this.formulaireServiceService.hasTranslation(
		  this.mapaRe.step + indexPage
		)
		  ? this.mapaRe.step + indexPage
		  : this.mapaRe.commonStep + indexPage;
	  }

    getContents(indexPage) {
      switch (indexPage) {
        case this.steps[0]:
        return [];
        case this.steps[1]:
        return [];
        case this.steps[2]:
        return [];
        case this.steps[3]:
        return [];
        case this.steps[4]:
        return [];
        case this.steps[5]:
        return [];
      }
    }
}

